export enum WindowSize {
  small = "small",
  medium = "medium",
  large = "large",
  xlarge = "xlarge",
}
